// Facebook Pixel Helper Functions

// Check if fbq is available
const isFbqAvailable = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

// Track standard events
export const trackPageView = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'PageView');
  }
};

export const trackLead = (params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Lead', params);
  }
};

export const trackInitiateCheckout = (params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Voucher Passeio de Barco - Desafio Hexa',
      content_category: 'Turismo',
      value: 147.00,
      currency: 'BRL',
      ...params
    });
  }
};

export const trackViewContent = (params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'ViewContent', {
      content_name: 'Landing Page Desafio Hexa',
      content_category: 'Turismo',
      value: 147.00,
      currency: 'BRL',
      ...params
    });
  }
};

// Custom events
export const trackCustomEvent = (eventName, params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('trackCustom', eventName, params);
  }
};

// Specific custom events for this landing page
export const trackPalpiteModalOpen = () => {
  trackCustomEvent('PalpiteModalOpen', {
    content_name: 'Modal de Palpite Aberto'
  });
};

export const trackPalpiteSelected = (palpite) => {
  trackCustomEvent('PalpiteSelected', {
    content_name: palpite === 'brasil_ganha' ? 'Brasil Campeão' : 'Brasil Não Ganha',
    palpite: palpite
  });
  
  // Also track as InitiateCheckout since they're being redirected to payment
  trackInitiateCheckout({
    content_name: `Voucher - Palpite: ${palpite === 'brasil_ganha' ? 'Brasil Campeão' : 'Brasil Não Ganha'}`,
    palpite: palpite
  });
};

export const trackWhatsAppClick = (source = 'unknown') => {
  trackCustomEvent('WhatsAppClick', {
    content_name: 'Clique WhatsApp',
    source: source
  });
  trackLead({ source: 'whatsapp' });
};

export const trackExitIntentShown = () => {
  trackCustomEvent('ExitIntentShown', {
    content_name: 'Popup de Saída Exibido'
  });
};

export default {
  trackPageView,
  trackLead,
  trackInitiateCheckout,
  trackViewContent,
  trackCustomEvent,
  trackPalpiteModalOpen,
  trackPalpiteSelected,
  trackWhatsAppClick,
  trackExitIntentShown
};
